import type { Dispatch, SetStateAction } from "react";

type ImageKeys = "small_image" | "medium_image" | "large_image" | "original_image" | "empty_image";

type ImageLoadingState = Record<ImageKeys, boolean>;

const handleSetProgressiveImageLoading = (
  imageKey: ImageKeys,
  setLoading: Dispatch<SetStateAction<ImageLoadingState>>
) => {
  setLoading((prevLoadings) => ({
    ...prevLoadings,
    [imageKey]: true
  }));
};

export { handleSetProgressiveImageLoading };
